import { FC } from "react";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import type { ProductInList } from "web/types/Product";

import Product from "./Product";
import classes from "./products.scss";

interface ISearchAutocompleteProducts {
  products: ProductInList[];
  closeAction: () => void;
  searchPhrase: string;
}

const SearchAutocompleteProducts: FC<ISearchAutocompleteProducts> = ({
  products = [],
  closeAction,
  searchPhrase = "",
}) => {
  return isArrayHasItems(products) ? (
    <span>
      {products.map((product, index) => {
        const productPosition = index + 1;

        return (
          <Product
            className={classes.item}
            key={product.id}
            closeAction={closeAction}
            product={product}
            searchPhrase={searchPhrase}
            productPosition={productPosition}
          />
        );
      })}
    </span>
  ) : null;
};

export default SearchAutocompleteProducts;
